import { DashboardComponentPair } from "../../../../models/dashboard";
import { JobDashboardComponent } from "./job-dashboard.component";
import { JobDashboardFormComponent } from "./job-dashboard-form.component";

export const ComponentPair: DashboardComponentPair = {
    view: JobDashboardComponent,
    form: JobDashboardFormComponent,
}
